import React from "react";
import { Mail } from "lucide-react";
import PolicyPage from "@/components/PolicyPage";

export default function Iletisim() {
  const cta = (
    <a
      href="mailto:destek@abonelikiptal.com"
      data-testid="contact-mailto"
      className="fs-btn-primary inline-flex items-center gap-2"
    >
      <Mail size={16} /> E-posta gönder
    </a>
  );
  return (
    <PolicyPage
      slug="iletisim"
      title="İletişim"
      intro="Abonelik İptal ile ilgili görüş, öneri veya destek talepleriniz için bizimle iletişime geçebilirsiniz."
      metaTitle="İletişim | Abonelik İptal"
      metaDescription="Abonelik İptal ile ilgili görüş, öneri ve destek talepleri için destek@abonelikiptal.com üzerinden bize ulaşın."
      cta={cta}
      sections={[
        {
          heading: "Destek e-posta adresi",
          body: [
            "destek@abonelikiptal.com — tüm görüş, öneri, hata bildirimi ve destek talepleriniz için birincil kanaldır. Hafta içi 1-3 iş günü içinde yanıtlamaya çalışırız.",
          ],
        },
        {
          heading: "Kişisel veri ve KVKK talepleri",
          body: [
            "Kişisel verilerinize ilişkin başvuru ve talepleriniz için yine destek@abonelikiptal.com adresini kullanabilirsiniz. Talebinizin konusunu e-postanızın konu satırında belirtmeniz süreci hızlandırır.",
          ],
        },
        {
          heading: "Hukuki bilgi",
          body: [
            "Abonelik İptal, resmi kurum değildir ve hukuki danışmanlık vermez. Acil hukuki ihtiyaçlarınız için mutlaka bir avukata veya ilgili resmi kuruma başvurun.",
          ],
        },
      ]}
    />
  );
}
